<style scoped>
.lucky-draw-count,
.cart-count {
    position: absolute;
    top: -4px;
    right: -2px;
    min-width: 1rem;
    height: 1rem;
    font-size: 0.65rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1px;
    @apply rounded-full bg-primary border border-white leading-none font-light;
}
.lucky-draw-count {
    @apply bg-red text-white;
}
.header-btn {
    @apply inline-flex items-center py-0 pt-0 px-1 cursor-pointer text-base whitespace-no-wrap;
}
.header-btn:focus {
    @apply outline-none text-white;
}
.logo_sm {
    height: 30px;
}
.logo_lg {
    height: 60px;
}

.topbar-wrapper {
    display: grid;
    display: -ms-grid;
    grid-template-columns: auto 1fr;
    -ms-grid-columns: auto 1fr;
    @apply bg-primary;
}
.logged-in.topbar-wrapper {
    @apply bg-transparent;
}
.dev-banner {
    grid-area: 1 / 1 / 1 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 8;
    -ms-grid-row: 1;
    @apply bg-red text-white text-center;
}
.demo-banner {
    grid-area: 1 / 1 / 1 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 8;
    -ms-grid-row: 1;
    @apply bg-green text-white text-center;
}
.top-banner-ads {
    grid-area: 2 / 1 / 2 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 8;
    -ms-grid-row: 2;
}
.site-logo {
    grid-area: 3 / 1 / 4 / 3;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
    -ms-grid-row: 3;
    justify-self: center;
    -ms-grid-row-align: center;
    display: flex;
    justify-content: center;
}
.logged-in ::v-deep .site-logo {
    grid-area: 3 / 1;
    -ms-grid-column: 1;
    -ms-grid-column-span: 1;
    -ms-grid-row: 3;
}
.header-links {
    grid-area: 4 / 1 / 5 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 7;
    -ms-grid-row: 4;
    /* justify-self: start; */
    -ms-grid-column-align: start;
    align-self: center;
    -ms-grid-row-align: center;
    @apply pt-2 w-full flex flex-wrap flex-row bg-primary;
}
.header-other-links {
    grid-area: 5 / 1 / 5 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 7;
    -ms-grid-row: 4;
    justify-self: start;
    -ms-grid-column-align: start;
    align-self: center;
    -ms-grid-row-align: center;
    justify-content: end;
    @apply pb-2 w-full flex flex-wrap flex-row bg-primary;
}
.sale-catg-links {
    @apply w-full flex flex-wrap items-start;
}
.sale-catg-links .menu-btn {
    @apply hidden whitespace-no-wrap;
}

@media (max-width: theme('screens.sm')) {
    .sale-catg-links {
        @apply mb-1;
    }
    .sale-catg-links:not(.sale-catg-links-expand) {
        @apply flex-no-wrap;
    }
    .sale-catg-links:not(.sale-catg-links-expand) .sale-catg-links-btns {
        @apply flex overflow-auto;
    }
    .sale-catg-links .sale-catg-links-btns::-webkit-scrollbar {
        display: none;
    }
    .sale-catg-links .sale-catg-links-btns {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
    .sale-catg-links.sale-catg-links-expand .menu-btn .icon {
        transform: rotate(180deg);
    }
    .sale-catg-links .menu-btn {
        @apply inline-flex ml-auto mr-1 outline-none border-2 border-white pr-1 rounded;
    }
}
.t-coins-links {
    grid-area: 3 / 3 / 4 / 8;
    -ms-grid-column: 3;
    -ms-grid-column-span: 5;
    -ms-grid-row: 3;
    margin-bottom: -2px;
    display: flex;
    align-items: center;
    @apply px-1 py-1;
    @apply text-sm font-black text-darkGrayishBlue;
}

.purchase-history-dropdown ::v-deep .dropdown,
.t-coin-dropdown ::v-deep .dropdown {
    left: 0;
    top: 100%;
    @apply bg-primary flex flex-col z-10;
}

.topbar-second-row-background {
    grid-area: 4 / 1 / 5 / 8;
    -ms-grid-column: 1;
    -ms-grid-column-span: 7;
    -ms-grid-row: 4;
    @apply w-full bg-primary;
}

.promotion-event-btn {
    background-color: rgb(255, 113, 106);
    @apply text-white border-white;
    @apply border-2 px-1;
}

.dropdown > * {
    @apply block px-2;
}

@screen sm {
    .logged-in.topbar-wrapper {
        grid-template-columns:
            auto repeat(5, minmax(auto, min(calc(100vw / 5), 15rem)))
            auto;
        -ms-grid-columns: auto
            repeat(5, minmax(auto, min(calc(100vw / 5), 15rem))) auto;
    }
    .logged-in ::v-deep .site-logo {
        grid-area: 3 / 4 / 4 / 5;
        -ms-grid-column: 1;
        -ms-grid-column-span: 7;
        -ms-grid-row: 3;
        -ms-grid-row-span: 1;
    }
    .logged-in ::v-deep .t-coins-links {
        grid-area: 4 / 2 / 5 / 4;
        -ms-grid-column: 2;
        -ms-grid-column-span: 2;
        -ms-grid-row: 4;
        -ms-grid-row-span: 1;
        align-self: center;
        -ms-grid-row-align: end;
        @apply bg-transparent text-base shadow-none;
    }
    .t-coins-links {
        @apply px-3;
    }
    .header-btn {
        @apply px-2;
    }
    .header-links {
        justify-content: flex-end;
        @apply w-auto;
    }
    .logged-in ::v-deep .header-links {
        grid-area: 4 / 2 / 5 / 7;
        -ms-grid-column: 4;
        -ms-grid-column-span: 3;
        -ms-grid-row: 4;
        -ms-grid-row-span: 1;
        -ms-grid-column-align: end;
        @apply pt-0 mt-3;
    }
    .header-other-links {
        justify-content: flex-end;
        @apply w-auto;
    }
    .logged-in ::v-deep .header-other-links {
        grid-area: 4 / 2 / 5 / 7;
        -ms-grid-column: 4;
        -ms-grid-column-span: 3;
        -ms-grid-row: 4;
        -ms-grid-row-span: 1;
        -ms-grid-column-align: end;
        justify-self: end;
        @apply pt-0 pb-1 mt-2 mb-1;
    }
    .sale-catg-links {
        display: contents;
        @apply w-auto;
    }
    .sale-catg-links .sale-catg-links-btns {
        display: contents;
    }
    .purchase-history-dropdown ::v-deep .dropdown,
    .t-coin-dropdown ::v-deep .dropdown {
        left: 0;
        top: 100%;
        @apply right-0 rounded-b-xl;
    }
}

.rdm-gift-button {
    background-color: #00adff;
    border-color: #ffffff;
    border-width: 2px;
    color: #ffffff;
}

.header-tcoin-icon {
    width: 1rem;
    height: 1rem;
}
</style>

<template>
    <header>
        <div id="topbar" class="bg-transparent sm:shadow">
            <div
                class=" mx-auto topbar-wrapper"
                :class="{
                    'logged-in':
                        user ||
                        bofUser ||
                        previewCmpyToken ||
                        isPreviewShoppingListByShopListKey
                }"
            >
                <div class="dev-banner" v-if="isDev">
                    Developement
                </div>
                <div class="demo-banner" v-else-if="isDemo">
                    Demo
                </div>

                <BannerAdvertisement
                    v-if="$route.meta.showTopBanner !== false"
                    type="banner"
                    class="top-banner-ads"
                />
                <div class="topbar-second-row-background"></div>

                <div class="site-logo">
                    <button
                        v-if="false"
                        class="menu-btn focus:outline-none sm:hidden ml-2"
                        @click="isMenuOpened = !isMenuOpened"
                    >
                        <div
                            class="icon"
                            :class="[
                                isMenuOpened
                                    ? 'text-secondary'
                                    : ' text-primary'
                            ]"
                        >
                            <menuSvg v-if="!isMenuOpened" />
                            <closeSvg v-else />
                        </div>
                    </button>
                    <router-link
                        tag="div"
                        class="px-2 py-2 sm:py-4 cursor-pointer"
                        :to="
                            previewCmpyToken
                                ? `/previewProducts/${previewCmpyToken}`
                                : '/'
                        "
                    >
                        <img
                            :src="logoUrl"
                            alt="TryHaLa"
                            class="logo_lg"
                            :class="{ 'hidden sm:inline-block': !!user }"
                        />
                        <img
                            :src="logoSmUrl"
                            alt="TryHaLa"
                            class="logo_sm sm:hidden"
                            v-if="user"
                        />
                    </router-link>
                </div>
                <div
                    class=" flex flex-wrap items-center text-white header-links relative "
                >
                    <div
                        class="flex relative mr-auto mb-2 w-full overflow-x-auto sm:overflow-visible sm:inline-flex sm:w-auto"
                        v-if="isPreviewShoppingListByShopListKey"
                    >
                        <div
                            class="sale-catg-links"
                            :class="{
                                'sale-catg-links-expand': isExpandSaleCatgMenu
                            }"
                        >
                            <div class="sale-catg-links-btns">
                                <router-link
                                    tag="button"
                                    :to="
                                        `/previewShoppingList/${$route.params.shopListKey}`
                                    "
                                    exact
                                    active-class="font-black"
                                    class="header-btn header-btn-always-display sm:border-r border-white"
                                >
                                    {{ $t('site.main') }}
                                </router-link>

                                <template
                                    v-for="(c,
                                    ci) in productListSaleCatgDisplayList"
                                >
                                    <router-link
                                        :key="ci"
                                        tag="button"
                                        :to="
                                            `/previewShoppingList/${$route.params.shopListKey}/${c.saleCatgSlctCode}`
                                        "
                                        @click.native="isMenuOpened = false"
                                        active-class="font-black header-btn-always-display"
                                        class="header-btn sm:border-r border-white"
                                        :class="{
                                            'header-btn-always-display': ci < 2
                                        }"
                                    >
                                        {{ c.saleCatgSlctDesp }}
                                    </router-link>
                                </template>
                            </div>

                            <button
                                class="menu-btn"
                                @click="
                                    isExpandSaleCatgMenu = !isExpandSaleCatgMenu
                                "
                            >
                                <div class="icon icon-scale">
                                    <expandMoreSvg />
                                </div>
                                {{
                                    isExpandSaleCatgMenu
                                        ? '收起選項'
                                        : '更多種類'
                                }}
                            </button>
                        </div>
                    </div>

                    <div
                        class="flex relative mb-2 mr-auto w-full overflow-x-auto sm:overflow-visible sm:inline-flex sm:w-auto"
                        v-else-if="user && !!isSalesLinkRoute"
                    >
                        <div
                            class="flex w-full overflow-x-auto sm:overflow-visible sm:inline-flex sm:w-auto"
                        >
                            <router-link
                                tag="button"
                                :to="'/'"
                                exact
                                active-class="font-black"
                                class="ml-auto header-btn border-r border-white"
                            >
                                {{ $t('site.main') }}
                            </router-link>
                            <router-link
                                tag="button"
                                to="/logout"
                                class="header-btn "
                                active-class="text-darkGrayishBlue"
                            >
                                <div
                                    class="inline-block relative pr-2 sm:mr-2 leading-none"
                                >
                                    <div class="icon icon-scale">
                                        <arrowExitSvg />
                                    </div>
                                    <span
                                        v-if="false"
                                        class="font-bold hidden sm:block"
                                        >{{ $t('login.logout') }}</span
                                    >
                                </div>
                            </router-link>
                        </div>
                    </div>

                    <div
                        class="flex relative mb-2 mr-auto w-full overflow-x-auto sm:overflow-visible sm:inline-flex sm:w-auto"
                        v-else-if="user || previewCmpyToken"
                    >
                        <div
                            class="sale-catg-links"
                            :class="{
                                'sale-catg-links-expand': isExpandSaleCatgMenu
                            }"
                        >
                            <div class="sale-catg-links-btns">
                                <router-link
                                    tag="button"
                                    :to="
                                        previewCmpyToken
                                            ? `/previewProducts/${previewCmpyToken}`
                                            : '/'
                                    "
                                    exact
                                    active-class="font-black"
                                    class="header-btn sm:border-r border-white"
                                >
                                    {{ $t('site.main') }}
                                </router-link>

                                <template
                                    v-for="(c,
                                    ci) in productListSaleCatgDisplayList"
                                >
                                    <router-link
                                        :key="ci"
                                        tag="button"
                                        :to="
                                            previewCmpyToken
                                                ? `/previewProducts/${previewCmpyToken}/${c.saleCatgSlctCode}`
                                                : `/products/${c.saleCatgSlctCode}`
                                        "
                                        @click.native="isMenuOpened = false"
                                        active-class="font-black"
                                        class="header-btn sm:border-r border-white"
                                    >
                                        {{ c.saleCatgSlctDesp }}
                                    </router-link>
                                </template>
                            </div>

                            <button
                                class="menu-btn"
                                @click="
                                    isExpandSaleCatgMenu = !isExpandSaleCatgMenu
                                "
                            >
                                <div class="icon icon-scale">
                                    <expandMoreSvg />
                                </div>
                                {{ isExpandSaleCatgMenu ? '收起' : '全部' }}
                            </button>
                        </div>

                        <template v-if="previewCmpyToken"> </template>
                    </div>

                    <div
                        class="text-blue header-links"
                        v-else-if="bofUser && !previewCmpyToken"
                    >
                        <router-link
                            tag="button"
                            to="/companyQuickJoin"
                            active-class="text-darkGrayishBlue"
                            class="header-btn sm:border-r border-white"
                            :exact="$route.name === 'companyQuickJoin'"
                        >
                            <div class="icon">
                                <accountSvg />
                            </div>
                            <div class="pl-1 hidden sm:block">
                                <span class="font-bold">{{
                                    bofUser.userId
                                }}</span>
                            </div>
                        </router-link>

                        <router-link
                            tag="button"
                            to="/logout"
                            class="header-btn "
                            active-class="text-darkGrayishBlue"
                        >
                            <div class="icon">
                                <arrowExitSvg />
                            </div>
                            <span class="font-bold hidden sm:block">
                                {{ $t('login.logout') }}
                            </span>
                        </router-link>
                    </div>

                    <div class="flex relative ml-auto mb-2">
                        <template
                            class="flex flex-wrap"
                            v-if="user && !isSalesLinkRoute"
                        >
                            <howToBecomeEnterpriseMemberModalButton
                                v-if="!isEnterpriseCustomer"
                                btnClass="btn border-2 border-primary text-primary sm:border-white sm:text-white focus:outline-none mr-1"
                            />
                            <howToGetTcoinModalButton
                                v-if="
                                    !!isEnterpriseCustomer &&
                                        !!isReferralAvailable
                                "
                                :msg="'介紹新會員'"
                                :btnClass="
                                    'btn border-2 border-white text-white px-1 sm:border-white sm:text-white focus:outline-none mr-1'
                                "
                            />
                            <router-link
                                v-if="firstRunningPromotionEvent"
                                tag="button"
                                :to="{
                                    name: 'promotionEvent',
                                    params: {
                                        eventId:
                                            firstRunningPromotionEvent.prmtEvntId
                                    }
                                }"
                                class="btn promotion-event-btn focus:outline-none"
                            >
                                <div
                                    class="inline-block relative sm:mr-1 leading-none"
                                >
                                    <img
                                        class=" w-4 h-4"
                                        :src="imgPrmtEvntGiftIcon"
                                    />
                                    <div
                                        v-if="
                                            firstRunningPromotionEvent.custTknCnt
                                        "
                                        class="lucky-draw-count"
                                    >
                                        {{
                                            firstRunningPromotionEvent.custTknCnt
                                        }}
                                    </div>
                                </div>
                                <span class="inline-block">
                                    {{
                                        firstRunningPromotionEvent.prmtEvntName
                                    }}
                                </span>
                            </router-link>
                        </template>

                        <template
                            v-if="isShowRdmGift && (user || previewCmpyToken)"
                        >
                            <router-link
                                tag="button"
                                :to="rdmGiftRoute"
                                @click.native="isMenuOpened = false"
                                class="btn rdm-gift-button ml-1 px-2"
                            >
                                <div
                                    class="header-tcoin-icon icon text-primary"
                                >
                                    <tryhalaCoinSvg />
                                </div>
                                {{ '換領禮品' }}
                            </router-link>
                        </template>

                        <template v-if="user">
                            <router-link
                                v-if="allowInviteFriendMember"
                                tag="button"
                                :to="{ name: 'friendMember' }"
                                @click.native="isMenuOpened = false"
                                active-class="font-black"
                                class="header-btn"
                            >
                                <img
                                    :src="sentimentImg"
                                    class="mr-1 hidden sm:block"
                                />
                                {{ '親友會員' }}
                            </router-link>

                            <buttonDropdown
                                class="header-btn purchase-history-dropdown"
                                :supportMouseover="true"
                                ref="purchaseHistoryDropdown"
                            >
                                <template #button>
                                    <div class="icon">
                                        <historySvg />
                                    </div>
                                </template>
                                <template #dropdown>
                                    <router-link
                                        tag="button"
                                        :to="{ name: 'orderHistory' }"
                                        active-class="font-black"
                                        class="header-btn my-2"
                                        @click.native="
                                            $refs.tcoinDropdown.closeDropdown();
                                            isMenuOpened = false;
                                        "
                                    >
                                        {{ $t('order.history') }}
                                    </router-link>
                                    <router-link
                                        tag="button"
                                        :to="{ name: 'eventTicketHistory' }"
                                        active-class="font-black"
                                        class="header-btn my-2"
                                        @click.native="
                                            $refs.tcoinDropdown.closeDropdown();
                                            isMenuOpened = false;
                                        "
                                    >
                                        {{ $t('event.ticket.history') }}
                                    </router-link>
                                </template>
                            </buttonDropdown>
                            <buttonDropdown
                                v-if="!isFriendCustomer"
                                class="header-btn t-coin-dropdown"
                                :supportMouseover="true"
                                ref="tcoinDropdown"
                            >
                                <template #button>
                                    <div class="icon">
                                        <tryhalaCoinSvg />
                                    </div>
                                </template>
                                <template #dropdown>
                                    <router-link
                                        tag="button"
                                        :to="{ name: 'feedback' }"
                                        active-class="font-black"
                                        class="header-btn my-2"
                                        @click.native="
                                            $refs.tcoinDropdown.closeDropdown();
                                            isMenuOpened = false;
                                        "
                                    >
                                        {{ '產品體驗回饋' }}
                                    </router-link>
                                    <router-link
                                        tag="button"
                                        :to="{ name: 'creditPointHistory' }"
                                        active-class="font-black"
                                        class="header-btn my-2"
                                        @click.native="
                                            $refs.tcoinDropdown.closeDropdown();
                                            isMenuOpened = false;
                                        "
                                    >
                                        {{ $t('credit.point.history') }}
                                    </router-link>
                                    <!--
                                <router-link
                                    tag="button"
                                    :to="{ name: 'tcoin' }"
                                    active-class="font-black"
                                    class="header-btn my-2"
                                    @click.native="
                                        $refs.tcoinDropdown.closeDropdown();
                                        isMenuOpened = false;
                                    "
                                >
                                    {{ 'T-Coins 獎賞詳情' }}
                                </router-link>
                                -->
                                </template>
                            </buttonDropdown>
                            <div class=" inline-flex items-center">
                                <router-link
                                    tag="button"
                                    to="/account"
                                    active-class="text-darkGrayishBlue"
                                    class="header-btn ml-auto"
                                    :class="{ 'router-link-active': false }"
                                    :exact="
                                        $route.name === 'creditPointHistory'
                                    "
                                >
                                    <div class="icon icon-scale">
                                        <personSvg />
                                    </div>
                                </router-link>

                                <router-link
                                    tag="button"
                                    to="/cart"
                                    class="header-btn"
                                    active-class="text-darkGrayishBlue"
                                    v-if="isShoppingListOpen"
                                >
                                    <div
                                        class="inline-block relative leading-none"
                                    >
                                        <div class="icon icon-scale">
                                            <shoppingCartSvg />
                                        </div>
                                        <div class="cart-count">
                                            {{ cartTotalCategory }}
                                        </div>
                                    </div>
                                </router-link>
                                <router-link
                                    v-if="false"
                                    tag="button"
                                    to="/logout"
                                    class="header-btn "
                                    active-class="text-darkGrayishBlue"
                                >
                                    <div
                                        class="inline-block relative pr-2 sm:mr-2 leading-none"
                                    >
                                        <div class="icon icon-scale">
                                            <arrowExitSvg />
                                        </div>
                                        <span
                                            v-if="false"
                                            class="font-bold hidden sm:block"
                                            >{{ $t('login.logout') }}</span
                                        >
                                    </div>
                                </router-link>
                            </div>
                        </template>
                        <template
                            v-if="previewCmpyToken"
                            class="text-white header-other-links relative"
                        >
                            <router-link
                                tag="button"
                                :to="
                                    previewCmpyToken
                                        ? `/login/${previewCmpyToken}`
                                        : '/login'
                                "
                                active-class="font-black"
                                class="header-btn ml-auto sm:ml-0 "
                            >
                                <div
                                    class="hidden relative pr-1 sm:mr-1 leading-none"
                                >
                                    <div class="icon">
                                        <arrowEnterSvg />
                                    </div>
                                </div>
                                <span class="font-bold block">
                                    {{ $t('login.member.login') }}
                                </span>
                            </router-link>
                            <router-link
                                v-if="enableCreateAccount"
                                tag="button"
                                :to="`/createAccount/${previewCmpyToken}`"
                                class="header-btn sm:border-l border-white"
                                active-class="text-darkGrayishBlue"
                            >
                                <div
                                    class="hidden relative pr-1 sm:mr-1 leading-none"
                                >
                                    <div class="icon">
                                        <personAddSvg />
                                    </div>
                                </div>
                                <span class="font-bold block">{{
                                    $t('register.register.now')
                                }}</span>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
// import facebookSvg from '@/assets/svg/facebook.svg';
import accountSvg from '@/assets/svg/account.svg';
import personSvg from '@/assets/svg/person.svg';
import shoppingCartSvg from '@/assets/svg/shopping_cart.svg';
import arrowExitSvg from '@/assets/svg/arrow_exit.svg';
import arrowEnterSvg from '@/assets/svg/arrow_enter.svg';
import menuSvg from '@/assets/svg/menu.svg';
import closeSvg from '@/assets/svg/close.svg';
import expandMoreSvg from '@/assets/svg/expand_more.svg';
// import logo7_optimized from '@/assets/logo7_optimized.jpg';
// import logo8_optimized from '@/assets/logo8_optimized.png';
import logo6_optimized from '@/assets/logo6_optimized.png';
import logo6_sm from '@/assets/logo6_sm_optimized.png';
import img2s28 from '@/assets/img/2-28.png';
import personAddSvg from '@/assets/svg/person_add.svg';
import numberWithCommas from './numberWithCommasFilter';
import buttonDropdown from './buttonDropdown.vue';
import howToBecomeEnterpriseMemberModalButton from './howToBecomeEnterpriseMemberModalButton.vue';
import howToGetTcoinModalButton from './howToGetTcoinModalButton.vue';
import clickOutside from '../directives/clickOutside';
import imgPrmtEvntGiftIcon from '@/assets/img/promotion_event_gift_icon.png';
import BannerAdvertisement from './bannerAdvertisement.vue';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import historySvg from '@/assets/svg/description.svg';

export default {
    components: {
        // facebookSvg,
        accountSvg,
        personSvg,
        shoppingCartSvg,
        arrowExitSvg,
        arrowEnterSvg,
        menuSvg,
        closeSvg,
        expandMoreSvg,
        personAddSvg,
        buttonDropdown,
        howToBecomeEnterpriseMemberModalButton,
        howToGetTcoinModalButton,
        BannerAdvertisement,
        tryhalaCoinSvg,
        historySvg
    },
    directives: {
        clickOutside
    },
    created() {
        // this.logoWhiteUrl = logo8_optimized;
        this.logoUrl = logo6_optimized;
        this.logoSmUrl = logo6_sm;
        this.sentimentImg = img2s28;
        this.imgPrmtEvntGiftIcon = imgPrmtEvntGiftIcon;
    },
    data() {
        return {
            showLogout: false,
            currentLogo: 0,
            isMenuOpened: false,
            isTcoinMenuOpened: false,
            isExpandSaleCatgMenu: false
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        bofUser() {
            return this.$store.state.bofUser;
        },
        cartTotalCategory() {
            return (this.$store.state.cartItems || []).length;
        },
        crdtPntBal() {
            return numberWithCommas(this.$store.state.crdtPntBal);
        },
        isDev() {
            return process?.env?.VUE_APP_CONTEXT_PATH === '/tryhaladev/';
        },
        isDemo() {
            return process?.env?.VUE_APP_CONTEXT_PATH === '/tryhalademo/';
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        isShoppingListOpen() {
            return this.$store.getters.isShoppingListOpen;
        },
        sharingCmpyToken() {
            return this.user?.cmpyEmailTknNum || this.previewCmpyToken;
        },
        cmpyPreviewProductsUrl() {
            return this.sharingCmpyToken
                ? `${location.origin}${process.env.BASE_URL}previewProducts/${this.sharingCmpyToken}`
                : undefined;
        },
        allowInviteFriendMember() {
            return this.$store.getters.allowInviteFriendMember;
        },
        isEnterpriseCustomer() {
            return this.$store.getters.isEnterpriseCustomer;
        },
        isFriendCustomer() {
            return this.$store.getters.isFriendCustomer;
        },
        firstRunningPromotionEvent() {
            return this.$store.getters.firstRunningPromotionEvent;
        },
        isSalesLinkRoute() {
            return this.$route.name === 'salesLink';
        },
        isPreviewShoppingListByShopListKey() {
            return this.$store.getters.isPreviewShoppingListByShopListKey;
        },
        productListSaleCatgDisplayList() {
            return this.$store.getters.productListSaleCatgDisplayList;
        },
        isReferralAvailable() {
            return (
                this.$store.state.enableReferral &&
                this.user?.refActvInd === 'Y'
            );
        },
        isShowRdmGift() {
            return this.$store.state.enblRdmGift;
        },
        rdmGiftRoute() {
            return this.$store.getters.rdmGiftRoute();
        },
        enableCreateAccount() {
            return this.$store.state.enblCreAcct;
        }
    },
    methods: {
        switchLogo() {
            let next = this.currentLogo == 2 ? 0 : this.currentLogo + 1;
            this.currentLogo = next;
        }
    }
};
</script>
